import fleetApi from '../../services/fleetApi';
import { BULK_MAX, buildDeviceListQuery } from './fleet-utils';

const RESOLVE_PAGE_SIZE = 100;

const CHANGED = 'The device list changed while resolving; try again';

// The ids behind a filter, read by pages of 100. The page sort is dropped: a
// list sorted by a moving column (Last seen, Status) shifts devices between
// page reads, so a device could be read twice and another missed. The default
// order is stable. After paging, the distinct ids must equal the count of page
// 1; anything else is refused, never returned as a partial set.
export async function fetchAllDeviceIds(filters) {
  const { ordercolumn, orderby, ...unsorted } = filters || {};
  const read = (page) =>
    fleetApi.listDevices(buildDeviceListQuery({ ...unsorted, page, pageSize: RESOLVE_PAGE_SIZE }));

  const first = await read(1);
  const totalRecords = first.data.totalRecords || 0;
  if (totalRecords > BULK_MAX) {
    return { ok: false, error: `Narrow the filter to ${BULK_MAX} devices or fewer`, totalRecords };
  }
  const seen = new Set((first.data.data || []).map((d) => d.id));
  const pages = Math.ceil(totalRecords / RESOLVE_PAGE_SIZE);
  for (let page = 2; page <= pages; page += 1) {
    const res = await read(page);
    (res.data.data || []).forEach((d) => seen.add(d.id));
  }
  if (seen.size !== totalRecords) return { ok: false, error: CHANGED, totalRecords };
  return { ok: true, ids: [...seen], totalRecords };
}
